import React, { useEffect } from "react";
import { Grid, Message, Icon, Header, HeaderContent } from "semantic-ui-react";
import DOMPurify from "dompurify";
import AnimatedCheckIcon from "./shared/AnimatedCheckIcon";
import { Card, Col, Container, Row } from "reactstrap";
import AnimatedCrossIcon from "./shared/AnimatedCrossIcon";

const NextStepComponent = ({ message, typeMessage, url }) => {
  const [showUrl, setShowUrl] = React.useState("");
  useEffect(() => {
    setShowUrl(url);
    if (typeMessage === "REDIRECT") {
      window.location.replace(url);
    }
  }, [url]);
  return (
    <div>
      {typeMessage === "EMBEDDED" && (
        <iframe
          title="url"
          src={showUrl}
          style={{ display: "block", width: "100%", border: "none", height: "100vh" }}
        />
      )}
      <Container fluid>
        <Row></Row>
        <Row className="justify-content-center">
          <Col xs="12" md="6">
            <Card body className="p-5">
              {typeMessage === "ERROR" && (
                <div className="text-center">
                  <AnimatedCrossIcon />
                  <h1 className="mt-4 mb-4 error-message">Payment processing error</h1>
                  <h5
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
                    style={{ fontSize: "large", color: "#333333" }}
                  />
                </div>
              )}
              {typeMessage === "MESSAGE" && (
                <div className="text-center">
                  <AnimatedCheckIcon />
                  <h1 className="mt-4 mb-4 success-message">Payment has been processed</h1>
                  <h5
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
                    style={{ fontSize: "large", color: "#333333" }}
                  />
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NextStepComponent;
